module.exports = __webpack_public_path__ + "img/avatar5.e9344592.png";